import { Component, OnInit, Input } from '@angular/core';
import { UtilService, TranslationService } from 'src/app/shared';
import { IValidationComponent } from 'src/app/shared/widgets/component/ivalidation.component';
import { ValidationResult } from 'src/app/shared/widgets/validators/validation-result.model';
import { EventRead } from '../../shared/event-read.model';
import { RegistrationUpsert } from '../../shared/registration/crud/registration-upsert.model';
import { InvoiceService } from 'src/app/revenue/shared/invoice/invoice.service';

@Component({
  selector: 'wl-event-v4-registration-wizard-modification-options',
  templateUrl: './event-v4-registration-wizard-modification-options.component.html',
  styleUrl: './event-v4-registration-wizard-modification-options.component.less',
    standalone: false
})
export class EventV4RegistrationWizardModificationOptionsComponent implements IValidationComponent {
  @Input() public hasPaymentAmount: boolean = true;
  @Input() public hasRefundableCcPayment: boolean = false;
  @Input() public lineItemAccountingPackageIds: Array<number> = [];
  @Input() public paymentAccountingPackageIds: Array<number> = [];

  public _utilService: UtilService;
  public _translationService: TranslationService;

  public registrationId: number;
  public registration: RegistrationUpsert = new RegistrationUpsert();
  public event: EventRead = new EventRead();
  public initialLoadComplete: boolean = false;

  public constructor(
    utilService: UtilService,
    translationService: TranslationService,
    private _invoiceService: InvoiceService
  ) {
    this._utilService = utilService;
    this._translationService = translationService;

    this.registrationId = 0;
  }

  public loadData() {
    this.initialLoadComplete = true;
  }

  public getValidationResult(): ValidationResult {
    let valid = new ValidationResult();
    valid.isValid = true;

    if (this.registration.ModificationOptions.DoNotModifyInvoice == false) {
      if (
        this.registration.IsEdit &&
        this.registration.ModificationOptions.CreateUnappliedPayments == true &&
        this.registration.ModificationOptions.UnappliedPaymentPaymentypeId <= 0
      ) {
        //
        valid.isValid = false;
        valid.errors.push(
          this._translationService.getInstant(
            'events.registration.wizard.payment-info.modification-option-unapplied-payment-type-needed-validation-error'
          )
        );
      }
      if (this.registration.IsEdit && this.hasPaymentAmount && this.registration.ModificationOptions.PaymentAdjustmentTypeId <= 0) {
        //
        valid.isValid = false;
        valid.errors.push(
          this._translationService.getInstant(
            'events.registration.wizard.payment-info.modification-option-payment-adjustment-type-needed-validation-error'
          )
        );
      }
      if (this.registration.IsEdit && this.registration.ModificationOptions.InvoiceAdjustmentTypeId <= 0) {
        //
        valid.isValid = false;
        valid.errors.push(
          this._translationService.getInstant(
            'events.registration.wizard.payment-info.modification-option-invoice-adjustment-type-needed-validation-error'
          )
        );
      }
    }

    return valid;
  }

  /**
   * don't let Create Unapplied payments and Refund both be selected
   * @param selected
   */
  public handleCreateUnappliedPaymentsChanged(selected: boolean): void {
    if (selected) {
      this.registration.ModificationOptions.RefundCreditCardPayments = false;
    }
  }

  /**
   * don't let Create Unapplied payments and Refund both be selected
   * @param selected
   */
  public handleRefundCreditCardPaymentsChanged(selected: boolean): void {
    if (selected) {
      this.registration.ModificationOptions.CreateUnappliedPayments = false;
    }
  }

  /**
   * don't let Create Unapplied payments and Refund be selected
   * @param selected
   */
  public handleDoNotModifyInvoiceChanged(selected: boolean): void {
    this.registration.ModificationOptions.DoNotModifyInvoice = selected;

    if (selected) {
      this.registration.ModificationOptions.CreateUnappliedPayments = false;
      this.registration.ModificationOptions.RefundCreditCardPayments = false;
    }
  }
}
